import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const LS_COOKIE = "indosbook_cookie_consent";

// Cookie consent banner shown on first visit. Persists the choice.
const CookieConsent = ({ onAccepted }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const choice = localStorage.getItem(LS_COOKIE);
    if (!choice) {
      const t = setTimeout(() => setVisible(true), 900);
      return () => clearTimeout(t);
    } else if (choice === "accepted") {
      onAccepted && onAccepted();
    }
  }, [onAccepted]);

  const choose = (val) => {
    localStorage.setItem(LS_COOKIE, val);
    setVisible(false);
    if (val === "accepted" && onAccepted) onAccepted();
  };

  if (!visible) return null;

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-0 z-[60] px-4 pb-4 sm:pb-6">
      <div className="pointer-events-auto mx-auto max-w-3xl rounded-2xl border border-gray-200 bg-white p-4 shadow-2xl sm:p-5">
        <div className="flex items-start gap-3">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#FF4500]/10">
            <Cookie className="h-5 w-5 text-[#FF4500]" />
          </span>
          <div className="min-w-0 flex-1">
            <p className="font-bold text-gray-900">We use cookies</p>
            <p className="mt-1 text-sm leading-relaxed text-gray-600">
              Indosbook uses cookies to keep you signed in, remember your
              preferences and improve the platform. By accepting, you agree to
              our{" "}
              <Link to="/legal/cookies" className="font-semibold text-[#FF4500] hover:underline">
                Cookie Policy
              </Link>
              .
            </p>
            <div className="mt-3 flex flex-wrap items-center gap-2">
              <button
                onClick={() => choose("accepted")}
                className="h-10 rounded-full bg-[#FF4500] px-5 text-sm font-bold text-white transition-colors hover:bg-[#e03d00]"
              >
                Accept cookies
              </button>
              <button
                onClick={() => choose("declined")}
                className="h-10 rounded-full border border-gray-300 px-5 text-sm font-semibold text-gray-600 transition-colors hover:bg-gray-50"
              >
                Decline
              </button>
            </div>
          </div>
          <button
            onClick={() => choose("declined")}
            aria-label="Close"
            className="rounded-full p-1 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
